<template>
  <header-nav-bar
    class="layout__header-nav-bar"
    :is-super-admin="isSuperAdmin"
    :offer-id="offerId"
    :offer-title="offerTitle"
    :contest-title="contestTitle"
    @validate-all="onValidateAll"
    @contest-navigate="onContestNavigate"
    @offer-navigate="onOfferNavigate"
    @home-navigate="onHomeNavigate"
  />

  <w-col class="layout__body" :size="12">
    <aside-tabs
      class="layout__body__aside"
      :tabs="sections"
      :current-tab-name="selectedSection.name"
      @change-tab="setSection"
    />

    <w-col class="layout__body__container" direction="col" :size="10">
      <w-col direction="col" class="layout__body__container__content" :size="12">
        <stage-container
          :active-section="selectedSection"
          :is-last-index="isLastIndex"
          :is-first-index="isFirstIndex"
          @next-clicked="nextSection"
          @prev-clicked="prevSection"
          @save="onSave"
        >
          <template v-for="slot in slots" #[slot]>
            <slot :name="slot">
              <div>No content provided for slot: {{ slot }}</div>
            </slot>
          </template>
        </stage-container>
      </w-col>

      <stage-footer
        :need-autosave="needAutosave"
        :project-name="projectName"
        :version="version"
        :disable-first="isFirstIndex"
        :disable-last="isLastIndex"
        :sections="sections"
        :active-section="selectedSection"
        @prev-clicked="prevSection"
        @next-clicked="nextSection"
        @save="onSave"
        @cancel="onCancel"
      />
    </w-col>
  </w-col>
</template>

<script setup lang="ts">
import { useSlots } from 'vue';

import type { Section } from '@/typings/section';

import AsideTabs from './AsideTabs.vue';
import HeaderNavBar from './HeaderNavBar.vue';
import StageContainer from './stage/StageContainer.vue';
import StageFooter from '../components/stage/StageFooter.vue';

const {
  version,
  projectName,
  offerId,
  offerTitle,
  contestTitle,
  isFirstIndex,
  isLastIndex,
  isSuperAdmin,
  sections,
  selectedSection,
  prevSection,
  nextSection,
  onSave,
} = defineProps<{
  offerId: number;
  version: string;
  projectName: string;
  offerTitle: string;
  contestTitle: string;
  needAutosave: boolean;
  isFirstIndex: boolean;
  isLastIndex: boolean;
  isSuperAdmin: boolean;
  sections: Section[];
  selectedSection: Section;
  prevSection: () => any;
  nextSection: () => any;
  setSection: (Section: Section) => any;
  onSave: (leave: boolean) => any;
  onCancel: () => any;
  onValidateAll: () => any;
  onContestNavigate: () => any;
  onOfferNavigate: () => any;
  onHomeNavigate: () => any;
}>();

const slots: any = Object.keys(useSlots());
</script>

<style lang="scss">
.layout__body {
  &__container {
    display: flex;
    flex: 1 1 auto;

    &__content {
      padding: 2rem;
    }

    &__footer-nav-bar {
      margin-top: auto;
      display: flex;
      flex: 1 1 auto;
      align-items: stretch;
    }
  }
}
</style>
